import { transformToStatefulPromise } from "../fetchUtils/statefulPromise";
// The `use` API from React 19 is not a hook as it can be called within loops and conditionals.
// Although like React Hooks, it must be used in components or custom hooks.
// Hence, we are prefixing it with an underscore to bypass linting rules for validating rules of hooks.
// A similar implementation can be found in Apollo Client:
// https://github.com/apollographql/apollo-client/blob/d4fb0d2d4d806394cbd1d097dffba2a1446c91c2/src/react/hooks/internal/__use.ts
export function _use(promise) {
    const statefulPromise = transformToStatefulPromise(promise);
    switch(statefulPromise.status){
        case 'pending':
            throw statefulPromise;
        case 'fulfilled':
            return statefulPromise.value;
        case 'rejected':
            throw statefulPromise.reason;
    }
}

//# sourceMappingURL=use.js.map